import { useSearchPageExactSearchReturnedNoResults } from "@faire/retailer/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageExactSearchReturnedNoResults";
import { useSearchPageZeroIndexedPageNumber } from "@faire/retailer/views/search-v2/SearchPageQueryParams/useSearchPageZeroIndexedPageNumber";

export const useSearchPageShowNoProductResults = () => {
  const pageNumber = useSearchPageZeroIndexedPageNumber();
  const exactSearchReturnedNoResults =
    useSearchPageExactSearchReturnedNoResults();

  return exactSearchReturnedNoResults && pageNumber === 0;
};
